import { render, staticRenderFns } from "./BookSlider.vue?vue&type=template&id=219926f7&scoped=true&"
import script from "./BookSlider.vue?vue&type=script&lang=js&"
export * from "./BookSlider.vue?vue&type=script&lang=js&"
import style0 from "./BookSlider.vue?vue&type=style&index=0&id=219926f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219926f7",
  null
  
)

export default component.exports